import React from 'react';

export interface AwardeeTenderCountPillProps {
  count: number;
  awardeeId?: number | null;
  onFilterTenders?: (awardeeId: number) => void;
}

const AwardeeTenderCountPill: React.FC<AwardeeTenderCountPillProps> = ({
  count,
  awardeeId,
  onFilterTenders,
}) => {
  if (awardeeId == null) {
    return null;
  }

  const className =
    'inline-flex items-center px-1.5 py-0.5 rounded-full bg-yellow-100 text-yellow-800 border border-yellow-300 text-[11px] font-semibold hover:bg-yellow-200 shrink-0 whitespace-nowrap';
  const title = `${count} tender${count === 1 ? '' : 's'} awarded${onFilterTenders ? ' — filter Tenders list' : ''}`;

  if (onFilterTenders) {
    return (
      <button type="button" onClick={() => onFilterTenders(awardeeId)} className={className} title={title}>
        {count}
      </button>
    );
  }

  return (
    <span className={className} title={title}>
      {count}
    </span>
  );
};

export default AwardeeTenderCountPill;
